import type { IconSvgObject } from './types';

const CornerLeftUpIcon: IconSvgObject = [
  ["path", { d: "M9 5L9 12C9 15.7712 9 17.6569 10.1716 18.8284C11.3431 20 13.2288 20 17 20L20 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 8.99996C4 8.99996 7.68244 4.00001 9.00004 4C10.3176 3.99999 14 9 14 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CornerLeftUpIcon;
